import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

//Account Redux states
import { REGISTER_USER } from './actionTypes';
import { registerUserSuccessful, registerUserFailed } from './actions';

//Include Both Helper File with needed methods
import { Register } from '../../../apiHelpers/authHelper';
import toastr from "toastr";


// Is user register successfull then direct plot user in redux.
function* registerUser({ payload: { user } }) {
    try {
        const response = yield call(Register, '/api/v1/auth', user);
        if (response.data.status !== "error") {
            toastr.success("The user has been saved!", "Success");
            yield put(registerUserSuccessful());
            setTimeout(() => {
                window.location.href = "/login";
            }, 1500)
        } else {
            toastr.error("It seems the email informed already exists","Error");
            yield put(registerUserFailed());
        }
    } catch (error) {
        toastr.error("It seems the email informed already exists","Error");
        yield put(registerUserFailed());
    }
}

export function* watchUserRegister() {
    yield takeEvery(REGISTER_USER, registerUser);
}

function* accountSaga() {
    yield all([fork(watchUserRegister)]);
}

export default accountSaga;